export default __webpack_public_path__ + "static/media/close.e20279ac.svg";